import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { type FileRulesType } from 'utils/apiList/files'

import {
  HomeTabCreateEditStateType,
  HomeTabDetailType,
  HomeTabOptionType,
  HomeTabSegmentOptionType,
} from 'features/MultiCategory/@types/homeTabCreateEdit'

export const SLICE_NAME = 'multiCategoryHomeTabCreateEdit'

export const initialState: HomeTabCreateEditStateType = {
  isLoading: false,
  isSubmitting: false,
  detail: null,
  tabbingTypeOptions: [],
  segmentOptions: [],
  iconFileRule: null,
}

const multiCategoryHomeTabCreateEdit = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    resetState: () => initialState,
    setIsLoading: (state, { payload }: PayloadAction<boolean>) => {
      state.isLoading = payload
    },
    setIsSubmitting: (state, { payload }: PayloadAction<boolean>) => {
      state.isSubmitting = payload
    },
    setDetail: (state, { payload }: PayloadAction<HomeTabDetailType | null>) => {
      state.detail = payload
    },
    setTabbingTypeOptions: (state, { payload }: PayloadAction<HomeTabOptionType[]>) => {
      state.tabbingTypeOptions = payload
    },
    setSegmentOptions: (state, { payload }: PayloadAction<HomeTabSegmentOptionType[]>) => {
      state.segmentOptions = payload
    },
    setIconFileRule: (state, { payload }: PayloadAction<Nullable<FileRulesType>>) => {
      state.iconFileRule = payload
    },
  },
})

export const {
  resetState,
  setIsLoading,
  setIsSubmitting,
  setDetail,
  setTabbingTypeOptions,
  setSegmentOptions,
  setIconFileRule,
} = multiCategoryHomeTabCreateEdit.actions
export default multiCategoryHomeTabCreateEdit.reducer
